module.exports = __webpack_public_path__ + "img/img29.022a3e59.png";